import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs";
import ErrorSection from "@/components/Errormessage/Errormessage";
import Layout from "@/components/Layout/Layout";
import { fetchCommonData } from "@/services/CommonService";
import { useEffect, useState } from "react";

export default function NotFound() {
  const [commonData, setCommonData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchCommonData();
        setCommonData(response?.data || null);
      } catch (error) {
        console.error("Error fetching CMS data:", error);
        setCommonData(null);
      }
    };

    fetchData();
  }, []);

  return (
    <Layout pageTitle="404 Error" commonData={commonData}>
      <Breadcrumbs />
      <ErrorSection />
    </Layout>
  );
}
